import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-a-down-right",
  "use": "icon-a-down-right-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" class=\"feather feather-arrow-down-right\" id=\"icon-a-down-right\"><line x1=\"7\" y1=\"7\" x2=\"17\" y2=\"17\" /><polyline points=\"17 7 17 17 7 17\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol